import { render, staticRenderFns } from "./ShareOfVoicesChart.vue?vue&type=template&id=d9bd7594&scoped=true&"
import script from "./ShareOfVoicesChart.vue?vue&type=script&lang=js&"
export * from "./ShareOfVoicesChart.vue?vue&type=script&lang=js&"
import style0 from "./ShareOfVoicesChart.vue?vue&type=style&index=0&id=d9bd7594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bd7594",
  null
  
)

/* custom blocks */
import block0 from "./ShareOfVoicesChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports